// modules/EnquiryButton.js
import React         from 'react';
import Arrow  from '../images/arrow';

class EnquiryButton extends React.Component {

	triggerRegistration(i) {
		window.jQuery("#fld_7683514_1").val(this.props.comment);
		window.jQuery("#header_cta_enquire").trigger('click');
	}

	render() {
		return (
			<div className={this.props.bclass} onClick={this.triggerRegistration.bind(this)}>
				<div>{this.props.children}<Arrow/></div>
			</div>
		);
	}
}

export default EnquiryButton;


/** WEBPACK FOOTER **
 ** ./src/modules/common/EnquiryButton.js
 **/